export const COMPS_BOUNDARY_APPLY_ID = 'comps-boundary-apply'
